export interface LogoSource {
  url: string;
  priority: number;
}

export const getLogoSources = (domain: string): LogoSource[] => {
  // Remove www. if present
  const cleanDomain = domain.replace('www.', '');
  
  return [
    {
      url: `https://logo.clearbit.com/${cleanDomain}`,
      priority: 1
    },
    {
      url: `https://www.google.com/s2/favicons?domain=${cleanDomain}&sz=128`,
      priority: 2
    }
  ].sort((a, b) => a.priority - b.priority);
};

export const getLogoUrl = (domain: string): string => {
  const sources = getLogoSources(domain);
  return sources[0].url;
};
